import React, { Component } from "react";
import axios, { CancelToken } from "axios";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";

import FormListGuestUsers from "./FormListGuestUsers";
import FormAddGuestUser from "./FormAddGuestUser";
import FormPlatformPermissions from "./FormPlatformPermissions";
import TopBar from "./TopBarGuestUser";
import { setAlert } from "../../../../actions/alertActions";

import "../../../../styles/components/account/manageAccount/guestUser/AccessManagement.scss";

class AccessManagement extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;
    this.cancel = null;

    this.state = {
      step: 1,

      guestUsers: [],
      guestUser: [],
      values: {},
      guestUserId: null,

      isEditing: false,
    };

    this.fetchGuestUsersList = this.fetchGuestUsersList.bind(this);
    this.handleAddGuestUser = this.handleAddGuestUser.bind(this);
    this.handleEditGuestUser = this.handleEditGuestUser.bind(this);
    this.handleDeleteGuestUser = this.handleDeleteGuestUser.bind(this);
    this.getGuestUser = this.getGuestUser.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.fetchGuestUsersList();
  }

  componentWillUnmount() {
    if (this.cancel !== null) this.cancel("Component is unmounting");
    this._mounted = false;
  }

  fetchGuestUsersList() {
    axios
      .get("/api/private/guestUsers")
      .then((res) => {
        if (res.status === 200) {
          this.safeSetState({
            guestUsers: res.data,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  nextStep = () => {
    const { step } = this.state;
    this.setState({
      step: step + 1,
    });
  };

  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };

  handleChangeValue = (values) => {
    this.setState({ values: values });
  };

  handleAddGuestUser(values, ownerId) {
    const post = {
      name: values.name,
      email: values.email,
      password: values.password,
      ownerId: ownerId,
      accessPlatform: {
        api: values.api,
        webclient: values.webclient,
        mobile: values.mobile,
      },
      active: true,
    };

    axios
      .post("/api/private/guestUsers", post)
      .then((res) => {
        if (res.status === 200) {
          this.fetchGuestUsersList();
          this.props.setAlert(
            I18n.t("guestUser_addGuestUserSuccess"),
            "primary"
          );
          this.setState({
            step: 1,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  getGuestUser(id) {
    axios
      .get("/api/private/guestUsers/byId", {
        params: {
          guestUserId: id,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            guestUser: res.data,
            guestUserId: id,
            isEditing: true,
          });
          this.nextStep();
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  handleEditGuestUser(values, ownerId) {
    const patch = {
      name: values.name,
      email: values.email,
      password: values.password,
      _id: this.state.guestUserId,
      ownerId: ownerId,
      accessPlatform: {
        api: values.api,
        webclient: values.webclient,
        mobile: values.mobile,
      },
      active: true,
    };

    axios
      .patch("/api/private/guestUsers", patch)
      .then((res) => {
        if (res.status === 200) {
          this.fetchGuestUsersList();
          this.props.setAlert(
            I18n.t("guestUser_editGuestUserSuccess"),
            "primary"
          );
          this.setState({
            step: 1,
          });
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  handleDeleteGuestUser(id) {
    axios
      .delete("/api/private/guestUsers", {
        data: {
          guestUserId: id,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          this.fetchGuestUsersList();
          this.props.setAlert(
            I18n.t("guestUser_deleteGuestUserSuccess"),
            "primary"
          );
        }
      })
      .catch((err) =>
        this.props.setAlert(
          I18n.t(err?.response?.data?.code || "general_errorMessage"),
          "danger"
        )
      );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  stepDisplay() {
    const { step } = this.state;
    const list = this.state.guestUsers;
    const userInfo = this.state.guestUser;

    switch (step) {
      case 1:
        return (
          <>
            <TopBar setContent={this.props.setContent} />
            <FormListGuestUsers
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              list={list}
              deleteGuestUser={this.handleDeleteGuestUser}
              getGuestUser={this.getGuestUser}
            />
          </>
        );
      case 2:
        return (
          <>
            <TopBar setContent={this.props.setContent} />
            <FormAddGuestUser
              nextStep={this.nextStep}
              prevStep={this.prevStep}
              userInfo={userInfo}
              handleChange={this.handleChangeValue}
              isEditing={this.state.isEditing}
            />
          </>
        );
      case 3:
        return (
          <>
            <TopBar setContent={this.props.setContent} />
            <FormPlatformPermissions
              prevStep={this.prevStep}
              userInfo={userInfo}
              isEditing={this.state.isEditing}
              ownerId={this.props.accountData.id}
              values={this.state.values}
              addGuestUser={this.handleAddGuestUser}
              editGuestUser={this.handleEditGuestUser}
            />
          </>
        );
      default:
        return (
          <>
            <TopBar setContent={this.props.setContent} />
            <FormListGuestUsers
              nextStep={this.nextStep}
              handleChange={this.handleChange}
              list={list}
              deleteGuestUser={this.handleDeleteGuestUser}
              getGuestUser={this.getGuestUser}
            />
          </>
        );
    }
  }

  render() {
    return <>{this.stepDisplay()}</>;
  }
}

const mapStateToProps = (state) => ({
  accountData: state.account.accountData,
});

export default connect(mapStateToProps, { setAlert })(AccessManagement);
